module.exports = __webpack_public_path__ + "static/media/f_animated_alpha.089682ac.gif";